export default "__VITE_ASSET__950da70c__"